var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',{attrs:{"name":"fade"}},[_c('div',{staticClass:"my-5"},_vm._l((_vm.portals),function(portal,index){return _c('div',{key:index},[_c('portal-card',{attrs:{"desc":portal.desc,"title":portal.title,"url":portal.url,"url_c":portal.url_c}})],1)}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }